const stringifer = (...args: any[]) =>
  args
    .map((arg) => {
      return `${arg}`;
    })
    .join("_");

export default stringifer;
